import * as React from 'react';

import { IconLogout24 } from './IconLogout24';
import * as styles from './Logout.css';

interface ILogoutProps {
  onClick(): void;
}

export const Logout: React.FC<ILogoutProps> = ({ onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <IconLogout24 color="icon-primary-default" />
      Выйти
    </div>
  );
};
